import { QueryClient } from "react-query";
import { stableQueryOptions } from "util/requests";

export const brandingQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            ...stableQueryOptions(),
        },
    },
});
